import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import { Grid, Box } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import bgStyles from "./Row.styles";
import type { RowProps } from "./Row.d";

const Row = ({
  pyMobile,
  mtMobile,
  mbMobile,
  pxMobile,
  pyTablet,
  mtTablet,
  mbTablet,
  pxTablet,
  pyDesktop,
  mtDesktop,
  mbDesktop,
  pxDesktop,
  bgStyle,
  id,
  display,
  content,
  sbEditable,
}: SbEditableComponentProps<RowProps>) => (
  <Box
    overflow="hidden"
    id={id}
    display={display}
    py={{ base: pyMobile, md: pyTablet, lg: pyDesktop }}
    mt={{ base: mtMobile, md: mtTablet, lg: mtDesktop }}
    mb={{ base: mbMobile, md: mbTablet, lg: mbDesktop }}
    px={{ base: pxMobile, md: pxTablet, lg: pxDesktop }}
    {...bgStyles[bgStyle as string]}
    {...sbEditable}
  >
    <Grid
      templateColumns={{ base: "repeat(4, 1fr)", md: "repeat(6, 1fr)", lg: "repeat(12, 1fr)" }}
      maxW={MAX_GRID_WIDTH}
      mx="auto"
      gap={4}
    >
      {content.map((item) => (
        <DynamicComponent blok={item} key={item._uid} />
      ))}
    </Grid>
  </Box>
);

export default Row;
